import styled from "styled-components";

const Main = styled.main`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;
  background: var(--main-bg-color);
  overflow: hidden;
`;

export default Main;
